import service from '@/services'

//
export default {
  namespaced: true,
  state: {
    datas: [],
    myDatas: [],
  },
  mutations: {
    SET_DATA(state, data) {
      state.datas = data
    },
    SET_MY_DATA(state, data) {
      state.myDatas = data
    },
  },
  actions: {
    async getMyData({ commit }, params = {}) {
      try {
        const config = {
          url: '/gudang-sales-rute',
          method: 'get',
          params,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        const result = response.data && response.data.data ? response.data.data : []
        commit('SET_MY_DATA', result)

        return Promise.resolve(result)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getDataById({ commit }, id) {
      try {
        const config = {
          url: `/rute/${id}`,
          method: 'get',
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getData({ commit }, params = {}) {
      try {
        const config = {
          url: '/rute',
          method: 'get',
          params,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        const result = response.data && response.data.data ? response.data.data : []
        const total = response.data && typeof response.data.total !== 'undefined'
          ? response.data.total
          : result.length
        commit('SET_DATA', result)

        return Promise.resolve(Object.assign(result, { total }))
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getMyRouteJoin({}, params = {}) {
      try {
        const config = {
          url: '/select-rute-sales',
          method: 'get',
          params,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async save({}, payload = {}) {
      try {
        const config = {
          url: '/input/rute',
          method: 'post',
          data: payload,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async saveMyData({}, payload = {}) {
      try {
        const config = {
          url: '/input/gudang-sales-rute',
          method: 'post',
          data: payload,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
  },
}
